import SpotType from "../types/SpotType";

export default function getSpotTypeByNameAndPriority(
  spotTypes: SpotType[],
  name: string,
  priority: "primary" | "secondary"
): SpotType {
  return spotTypes.find(t => t.name === name && t.priority === priority);
}
